<template>
  <div class="about_us_container">
    <div class="about_us_box">
      <div class="content_box">
        <div class="h4">
          <span>互联网新闻信息服务许可证编号：10120170020</span>
        </div>
        <div class="h4">
          <span>1.服务条款确认</span>
        </div>
        <div class="block_box">
          <p>“法治号”客户端中各项服务的所有权和运营权归法治日报社所有，任何单位和个人非经本单位授权，不得以本单位及其所有的网站名义进行商业或非商业活动。</p>
          <p>“法治号”客户端提供的服务将严格按照本单位及本软件发布的服务条款和操作规则执行。用户必须确认所有服务条款并完成注册程序，才能成为“法治号”客户端的正式用户。</p>
        </div>
        <div class="h4">
          <span>2.版权声明</span>
        </div>
        <div class="block_box">
          <p>“法治号”客户端上的所有内容，包括但不限于文字、图片、声音、录像、图表、标志、标识、广告、商标、商号、域名、软件、程序、版面设计、内容分类标准以及为用户提供的任何信息，均受法律的保护，为法治日报社及其相关权利人专属所有或持有。</p>
          <p>使用者将“法治号”客户端提供的内容与服务用于非商业用途、非盈利、非广告目的而纯属个人使用时，应遵守相关法律的规定，不得侵犯法治日报社及其相关权利人的合法权益,否则将追究有关人员的侵权责任。</p>
        </div>
        <div class="h4">
          <span>3.服务修订</span>
        </div>
        <div class="block_box">
          <p>“法治号”客户端根据自身的服务内容，以及与用户达成的协议提供服务。用户在享用本软件提供的各项服务的同时，同意接受本软件提供的各类信息服务。</p>
          <p>法治日报社有权在必要时修改服务条款，如果不同意所改动的内容，用户可以在与法治日报社取得联系后取消获得的服务。如果用户继续享用服务，则视为接受服务条款的变动。</p>
          <p>法治日报社保留随时修改或中断服务而不需提前告知用户的权利。法治日报社行使修改或中断服务的权利，不需对用户或第三方负责。</p>
        </div>
        <div class="h4">
          <span>4.隐私保护</span>
        </div>
        <div class="block_box">
          <p>用户一旦注册成功，成为“法治号”客户端的合法用户，将得到一个用户名和密码。 由用户对用户名和密码安全负全部责任。另外，每个用户都要对以其用户名进行的所有活动和事件负全责。您可随时根据规则改变您的密码。用户若发现任何非法使用用户帐号或存在安全漏洞的情况，请立即通告法治日报社。</p>
          <p>法治日报社尊重用户个人隐私，未经合法用户授权，本软件不会在公开、编辑或透露其注册资料及保存在本软件的非公开内容，除非有法律许可要求或未经合法用户授权在诚信的基础上认为透露这些信息是必要的。</p>
        </div>
        <div class="h4">
          <span>5.风险承担</span>
        </div>
        <div class="block_box">
          <p>用户个人对本软件的使用自行承担风险。“法治号”客户端所提供的所有服务权限于对用户参考，不对用户的商业运作做任何具体性指导，用户应自行承担使用或提供本软件信息的商业活动及其风险。</p>
          <p>“法治号”客户端不保证服务一定能满足用户的要求，也不保证服务不会受中断。本软件将尽力保证服务的及时性、准确性、安全性，但对及时性、准确性、安全性等都不作任何具体承诺。</p>
        </div>
        <div class="h4">
          <span>6.免责事由</span>
        </div>
        <div class="block_box">
          <p>(1)“法治号”客户端对用户在接受服务过程中所受的任何直接、间接的损害不负责任，这些损害可能来自：不正当使用网络服务，在网上购买商品或进行同类型服务，在网上进行交易，非法使用网络服务或用户传送的信息有所变动等。</p>
          <p>(2)“法治号”客户端不对用户所发布信息的删除或储存失败负责。“法治号”客户端有判定用户的行为是否符合本软件服务条款的要求的保留权利，如果用户违背了服务条款的规定，法治日报社有中断对其提供服务的权利。</p>
          <p>(3)对用户自行提供的信息，由用户依法自行承担全部责任。法治日报社对此等信息的准确性、完整性、合法性或真实性均不承担任何责任。</p>
        </div>
        <div class="h4">
          <span>7.用户承诺</span>
        </div>
        <div class="block_box">
          <p>用户必须遵循：</p>
          <p>(1)用户必须提供真实的自我信息，对其在本软件上填写的信息负责全部责任。</p>
          <p>(2)使用网络服务不作非法用途。</p>
          <p>(3)不干扰或攻击网络服务。</p>
          <p>(4)遵守所有使用网络服务的网络协议、规定、程序和惯例。</p>
          <p>用户须承诺不传输任何非法的、骚扰性的、中伤他人的、辱骂性的、恐吓性的、伤害性的、庸俗的，淫秽等信息资料。</p>
          <p>用户特别承诺：用户一旦在“法治号”客户端注册，即以明示或默示的方式同意并允许法治日报社将用户信息等用于“法治号”客户端及开发的衍生产品中。但法治日报社在使用过程中应保证其公正的立场，正确反应客观事实，不得恶意诋毁或损害用户的名誉。</p>
        </div>
        <div class="h4">
          <span>8.服务终止或中止</span>
        </div>
        <div class="block_box">
          <p>“法治号”客户端用户可根据合同约定或实际情况终止、中止一项或多项服务。“法治号”客户端不需对任何个人或第三方负责而随时中止服务。用户对后来的条款修改有异议，或对本软件的服务不满，可以行使如下权利：</p>
          <p>(1)停止使用本软件的服务。</p>
          <p>(2)通告法治日报社停止对该用户的服务。</p>
          <p>结束用户服务后，用户使用网络服务的权利立即终止或中止。</p>
        </div>
        <div class="h4">
          <span>9.通告形式</span>
        </div>
        <div class="block_box">
          <p>本服务条款的修改、服务变更、或其它重要事件发生变动而需要通告时，可根据实际情况选择通过重要页面公告等形式进行。</p>
        </div>
        <div class="h4">
          <span>10.法律适用</span>
        </div>
        <div class="block_box">
          <p>本软件服务条款与中华人民共和国的法律解释相一致，用户和法治日报社一致同意服从中华人民共和国法律的管辖。如发生本服务条款与中华人民共和国法律相抵触时，则这些条款将完全按法律规定重新解释，而其它条款则依旧保持对用户产生法律效力和影响。</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { loadStat } from "@/utils";
import commApi from "@/api/apis/common.js";
export default {
  name: "AboutUS",
  data() {
    return {};
  },
  computed: {
    ...mapState("app", ["nodeCode", "appFullName"]),
  },
  methods: {
    /* 微信二次分享 */
    wechatShare() {
      var _this = this;

      commApi.getWeiXinTicket({
        nodeCode: _this.nodeCode,
        url: location.href
      }).then((res) => {
        _this.$WeiXin.shareWeiXin(res, "关于我们 - 法治号客户端", _this.appFullName, location.href);
      }).catch((err) => {

      })
    },
  },
  created() {
    document.title = "关于我们";
    this.wechatShare(); // 微信二次分享
    loadStat(); // 友盟统计
  },
};
</script>
<style scoped lang="scss">
.about_us_container {
  width: 100%;
  height: 100%;
  padding: 0px;
  overflow-x: hidden;
  overflow-y: auto;
  .content_box {
    padding: 15px;
    .h4 {
      margin-top: 15px;
      color: #212121;
      font-size: 18px;
      font-family: "Microsoft Yahei";
      span {
        color: #212121;
        font-weight: bolder;
        font-size: 18px;
        font-family: "Microsoft Yahei";
      }
    }
    p {
      margin: 10px 0;
      line-height: 27px;
      color: #212121;
      font-size: 18px;
      font-family: "Microsoft Yahei";
      text-indent: 2em;
      text-align: justify;
      * {
        font-family: "Microsoft Yahei";
        text-align: justify;
      }
      .quotation {
        font-family: "Arial", sans-serif;
      }
      &.bottom_date {
        margin: 5px 0;
        text-align: right;
      }
    }
  }
}
</style>